import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section className="aboutus-section">
      <div className="aboutus-container">
        
        <motion.div
          className="aboutus-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="aboutus-badge">ABOUT US</span>
        </motion.div>

        <div className="aboutus-content">
          <motion.div 
            className="aboutus-image-wrapper"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <img 
              src="/logo.png" 
              alt="Data Bolta Hai Logo" 
              className="aboutus-logo" 
            />
          </motion.div>

          <motion.div 
            className="aboutus-text"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h2 className="aboutus-headline">Founded in 2003, by Relax Soft</h2>
            <p className="aboutus-desc">
              At Data Bolta Hai, we have young and experienced energetic professionals with a positive approach and a commitment to providing the best solutions for GST reconciliation and compliance automation. Our approach is backed by advanced algorithms, analytical skills, and IT tools to ensure error-free results, supporting better decision-making.
            </p>
            <Link to="/about" className="aboutus-cta">
              Discover More <FiArrowRight style={{ marginLeft: '8px' }} />
            </Link>
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;
